import {useEffect} from 'react'
import {Outlet} from 'react-router-dom'
import {useLocation} from 'react-router-dom'
import { AsideDefault } from '../aside'
import { HeaderWrapper } from '../header/HeaderWrapper';
import { Footer } from '../Footer'
import { Content } from '../Content'
import { MenuComponent } from '../../assets/components'
import { ScrollTop } from '../ScrollTop'

/**
 * Layout principal de la SPA: aside + header + content (Outlet) + footer + scroll-top.
 * Re-inicializa MenuComponent al montar y al cambiar de ruta.
 */
const Layout = () => {
  const location = useLocation()
  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])

  return (
    <>
      <div className='page d-flex flex-row flex-column-fluid'>
        <AsideDefault />
        <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'>
          <HeaderWrapper />

          <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>
            {/* <Toolbar /> */}
            <div className='post d-flex flex-column-fluid' id='kt_post'>
              <Content>
                <Outlet />
              </Content>
            </div>
          </div>
          <Footer />
        </div>
      </div>
      <ScrollTop />
    </>
  )
}

export {Layout}
